import Cookies from 'js-cookie'
import { COOKIES_DEVICE_ID } from '@/constants'
import { client } from '@/services/beef'
import { getAuthXToken } from '@/services/auth/authx-token-payload'

const cookiesAttr: Cookies.CookieAttributes = { path: '', secure: true, sameSite: 'None' }

/**
 * The security prefers the user device token to be the same even after the 60 days expiry.
 * The cookies operation in this file will attempt to make the user device token last permanently.
 * i.e. keeps extending the expiry date.
 */

export const getLocalUserDeviceToken = (): string | undefined => {
  const userDeviceToken = Cookies.get(COOKIES_DEVICE_ID)
  if (userDeviceToken) {
    Cookies.set(COOKIES_DEVICE_ID, userDeviceToken, {
      ...cookiesAttr,
      expires: 365, // unit=days, keeps extending the device ID expiry
    })
  }
  return userDeviceToken
}

export const generateNewUserDeviceToken = async () => {
  const authxToken = getAuthXToken()
  if (!authxToken) {
    throw new Error('user not authenticated')
  }
  const token = authxToken.value
  const res = await client.mfaGenerateUserDeviceToken({
    body: {
      token,
    },
  })
  const { userDeviceToken } = res
  Cookies.set(COOKIES_DEVICE_ID, userDeviceToken, {
    ...cookiesAttr,
    expires: 365, // unit=days, makes device ID last as long as possible
  })
  return userDeviceToken
}
